import * as React from "react"
import {
  ModalProps,
  Modal,
  ModalOverlay,
  ModalContent,
  ModalCloseButton,
  ModalBody,
  ModalHeader,
  Box,
  Flex,
  Spinner,
  Text,
} from "@chakra-ui/react"
import { useQuery } from "react-query"
import { FaCircle } from "react-icons/fa"
import { BikeEntity } from "../lib/types/bike"
import LiveChaseMapbox from "./LiveChaseMapbox"
import LiveChaseGoogleMaps from "./LiveChaseGoogleMaps"
import { useMapSettings } from "./providers/MapSettingsProvider"

interface LiveChaseModalProps extends Omit<ModalProps, "children"> {
  bikeId: string
}

export const LiveChaseModal: React.FC<LiveChaseModalProps> = ({ bikeId, ...props }) => {
  const { data: bike, isFetching } = useQuery<BikeEntity, string>(`bicycles/${bikeId}/`, {
    refetchInterval: 5000,
    enabled: props.isOpen,
  })

  const { mapProvider } = useMapSettings()

  return (
    <Modal {...props} isCentered size="xl">
      <ModalOverlay zIndex={100}>
        <ModalContent>
          <ModalHeader pb={0}>
            <Flex alignItems="center">
              <Box
                as={FaCircle}
                boxSize="20px"
                color="red.500"
                mr={4}
                css={{
                  webkitAnimation: "pulse 1s infinite ease-in-out",
                  oAnimation: "pulse 1s infinite ease-in-out",
                  msAnimation: "pulse 1s infinite ease-in-out",
                  mozAnimation: "pulse 1s infinite ease-in-out",
                  animation: "pulse 1s infinite ease-in-out",
                }}
              />
              <Text>Chasing {bike?.name}</Text>
              {isFetching && <Spinner size="sm" ml={4} />}
            </Flex>
          </ModalHeader>
          <ModalCloseButton />
          <ModalBody p={6} pointerEvents="none">
            {mapProvider === "google_maps" ? (
              <LiveChaseGoogleMaps bike={bike} />
            ) : (
              <LiveChaseMapbox bike={bike} />
            )}
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>
  )
}
